import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import { Box, Button, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

/**
 * Final section of our purchase training page
 */
const CallToAction = () => {
  return (
    <Box
      sx={{
        py: 8,
        textAlign: 'center',
        backgroundColor: 'primary.main',
        color: 'common.white',
      }}
    >
      <Typography variant="h4" component="h2" gutterBottom>
        Ready to Get Started?
      </Typography>
      <Button
        variant="contained"
        size="large"
        endIcon={<ChecklistRoundedIcon />}
        component={NavLink}
        to="/signup?onboarding=true"
        sx={{
          backgroundColor: 'white',
          color: 'black',
          '&:hover': {
            backgroundColor: '#dbdbdb',
          },
        }}
      >
        Begin Onboarding
      </Button>
    </Box>
  );
};

export default CallToAction;
